import {
  eachDayOfInterval,
  eachHourOfInterval,
  endOfDay,
  format,
  isWithinInterval,
  parseISO,
  startOfDay,
  subDays,
  subHours
} from 'date-fns'

export const parseDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return value
  try {
    return parseISO(value)
  } catch (e) {
    return null
  }
}

export const getDateRange = (filters) => {
  const today = new Date()
  const range = filters?.dateRange ?? 'today'

  if (range === 'last7') {
    return { start: startOfDay(subDays(today, 6)), end: endOfDay(today) }
  }
  if (range === 'last30') {
    return { start: startOfDay(subDays(today, 29)), end: endOfDay(today) }
  }
  if (range === 'custom' && filters?.startDate && filters?.endDate) {
    const start = parseDate(filters.startDate)
    const end = parseDate(filters.endDate)
    if (start && end && !isNaN(start.getTime()) && !isNaN(end.getTime()) &&
        start <= end && start.getFullYear() > 1970) {
      return { start: startOfDay(start), end: endOfDay(end) }
    }
  }
  return { start: startOfDay(today), end: endOfDay(today) }
}

export const isWithinRange = (dateValue, range) => {
  if (!dateValue || !range?.start || !range?.end) return false
  return isWithinInterval(dateValue, { start: range.start, end: range.end })
}

export const getLast24HoursBuckets = (endDate = new Date()) => {
  const start = subHours(endDate, 23)
  return eachHourOfInterval({ start, end: endDate }).map((hour) => ({
    hour,
    label: format(hour, 'HH:00')
  }))
}

export const getDailyBuckets = (range) => {
  if (!range?.start || !range?.end) return []
  if (range.start > range.end) return []
  const diffDays = Math.round((range.end - range.start) / (1000 * 60 * 60 * 24))
  if (diffDays > 366) return []
  return eachDayOfInterval({ start: range.start, end: range.end }).map((day) => ({
    day,
    label: format(day, 'dd/MM')
  }))
}

export const getRangeLabel = (filters) => {
  const range = filters?.dateRange ?? 'today'
  if (range === 'today') return 'hoje'
  if (range === 'last7') return 'ultimos 7 dias'
  if (range === 'last30') return 'ultimos 30 dias'
  if (range === 'custom' && filters?.startDate && filters?.endDate) {
    const start = parseDate(filters.startDate)
    const end = parseDate(filters.endDate)
    if (start && end) {
      return `${format(start, 'dd/MM')} - ${format(end, 'dd/MM')}`
    }
  }
  return 'periodo selecionado'
}

export const formatDateTime = (value) => {
  const date = parseDate(value)
  return date ? format(date, 'dd/MM/yyyy HH:mm') : '--'
}

export const formatDuration = (minutes) => {
  if (!Number.isFinite(minutes)) return '--'
  const totalMinutes = Math.max(0, Math.round(minutes))
  const hours = Math.floor(totalMinutes / 60)
  const mins = totalMinutes % 60
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`
}

export const formatSeconds = (seconds) => {
  if (!Number.isFinite(seconds)) return '--'
  const totalSeconds = Math.max(0, Math.round(seconds))
  const minutes = Math.floor(totalSeconds / 60)
  const remainder = totalSeconds % 60
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60
    return `${hours}h ${mins}m`
  }
  return `${minutes}m ${remainder}s`
}
